import type File from '../../interfaces/File';
import type { GetRecentFilesResponse, RecentFileEntry } from '../../interfaces/FileApiService';

function isRecentFileEntry(entry: unknown): entry is RecentFileEntry {
  if (typeof entry !== 'object' || entry === null) {
    return false;
  }
  const file = (entry as RecentFileEntry).file;
  return typeof file === 'object' && file !== null;
}

/** Maps `GET /myfiles/recent` entries into table rows with `lastOpenedAt` attached. */
export function mapRecentFilesToRows(response: GetRecentFilesResponse | null | undefined): File[] {
  const entries = response?.files;
  if (!Array.isArray(entries)) {
    return [];
  }
  // Skip malformed rows so a bad payload never throws in the Recent list render path.
  return entries.flatMap((entry) => {
    if (!isRecentFileEntry(entry)) {
      return [];
    }
    return [{ ...entry.file, lastOpenedAt: entry.lastOpenedAt }];
  });
}
